// extracted by mini-css-extract-plugin
export default {"input":"_base-input-question-text_input_FhI8A"};